"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TypeAction = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Icon = _interopRequireDefault(require("../atoms/Icon"));
var _Button = _interopRequireDefault(require("../atoms/Button"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let TypeAction = exports.TypeAction = /*#__PURE__*/function (TypeAction) {
  TypeAction["Edit"] = "edit";
  TypeAction["Delete"] = "delete";
  TypeAction["Info"] = "info";
  return TypeAction;
}({});
const defaultProps = {
  children: null,
  open: false,
  actions: {},
  direction: 'column'
};
function SwipeableItem(props) {
  const {
    children,
    open,
    direction,
    actions
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [isConfirming, setIsConfirming] = (0, _react.useState)(false);
  const isChoosingAction = (0, _react.useMemo)(() => isOpen && !isConfirming, [isOpen, isConfirming]);
  const actionsList = (0, _react.useMemo)(() => [...Object.entries(actions || {})], [actions]);
  const defaultIconsMap = {
    [TypeAction.Delete]: 'delete_forever',
    [TypeAction.Edit]: 'edit',
    [TypeAction.Info]: 'menu'
  };
  const onPress = type => {
    const [_, handler] = (actionsList === null || actionsList === void 0 ? void 0 : actionsList.find(_ref => {
      let [t] = _ref;
      return t === type;
    })) || [];
    if (typeof handler === 'function') {
      handler === null || handler === void 0 || handler();
      return;
    }
    const {
      confirm,
      onPress
    } = handler || {};
    if (confirm && !isConfirming) {
      setIsConfirming(true);
      return;
    }
    onPress === null || onPress === void 0 || onPress(type);
  };
  (0, _react.useEffect)(() => {
    setIsOpen(open);
    if (!open) setIsConfirming(false);
  }, [open]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    isChoosingAction: isChoosingAction,
    isConfirming: isConfirming
  }, /*#__PURE__*/_react.default.createElement(ActionsListWrapper, {
    direction: direction,
    isChoosingAction: isChoosingAction,
    actionsLength: actionsList === null || actionsList === void 0 ? void 0 : actionsList.length
  }, actionsList === null || actionsList === void 0 ? void 0 : actionsList.map(_ref2 => {
    let [type] = _ref2;
    return /*#__PURE__*/_react.default.createElement(ActionItem, {
      "data-type": type,
      key: type,
      onClick: () => onPress(type),
      type: "button",
      children: /*#__PURE__*/_react.default.createElement(_Icon.default, {
        size: 18,
        name: defaultIconsMap[type]
      })
    });
  })), /*#__PURE__*/_react.default.createElement(Content, {
    isChoosingAction: isChoosingAction,
    isConfirming: isConfirming,
    children: children
  }), /*#__PURE__*/_react.default.createElement(ConfirmationWrapper, {
    isConfirming: isConfirming
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "error",
    onClick: () => onPress(TypeAction.Delete),
    children: "Eliminar"
  })));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  overflow: hidden;\n"])));
const ActionsListWrapper = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  display: flex;\n  flex-direction: ", ";\n  transition: all 0.3s;\n\n  ", "\n"])), _ref3 => {
  let {
    direction
  } = _ref3;
  return direction;
}, _ref4 => {
  let {
    isChoosingAction,
    actionsLength
  } = _ref4;
  let styles = "\n      width: 0px;\n      margin-right: 0px;\n    ";
  if (isChoosingAction) {
    styles += "\n        width: ".concat(45 * actionsLength, "px;\n        margin-right: 10px;\n\n        @media screen and (min-width: 768px) {\n          width: ").concat(60 * actionsLength, "px;\n          margin-right: 15px;\n        }\n      ");
  }
  return styles;
});
const ActionItem = _styled.default.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  cursor: pointer;\n  border: none;\n  width: 100%;\n\n  ", "\n\n  @media screen and (min-width: 768px) {\n    span {\n      font-size: 24px;\n    }\n  }\n"])), _ref5 => {
  let {
    ['data-type']: dataType,
    theme
  } = _ref5;
  const colorsMap = {
    [TypeAction.Delete]: theme.colors.MAIN.ERROR,
    [TypeAction.Edit]: theme.colors.MAIN.INFO,
    [TypeAction.Info]: theme.colors.MAIN.WARNING
  };
  return "\n      background-color: ".concat(colorsMap[dataType], ";\n\n      * {\n        color: ").concat(theme.colors.NEUTRAL.BACKGROUND, ";\n      }\n    ");
});
const Content = _styled.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  transition: width 0.3s;\n\n  ", "\n"])), _ref6 => {
  let {
    isConfirming,
    isChoosingAction
  } = _ref6;
  if (isChoosingAction) return 'width: calc(100% - 30px);';
  if (isConfirming) return 'width: calc(100% - 75px);';
  return 'width: 100%';
});
const ConfirmationWrapper = _styled.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  transition: all 0.3s;\n  display: flex;\n  align-items: center;\n  width: 65px;\n  position: relative;\n  overflow: hidden;\n\n  button {\n    height: 100%;\n    border-radius: 0;\n    font-size: 10px;\n    padding: 0px;\n  }\n\n  @media screen and (min-width: 768px) {\n    min-width: fit-content;\n\n    button {\n      font-size: 12px;\n    }\n  }\n\n  ", "\n"])), _ref7 => {
  let {
    isConfirming
  } = _ref7;
  return isConfirming ? "\n    position: relative;\n    margin-left: 10px;\n  " : "\n    width: 0px;\n    \n    @media screen and (min-width: 768px) {\n      &, button {\n        width: 0;\n        padding: 0;\n        overflow: hidden;\n        border: 0;\n      }\n    }\n  ";
});
var _default = exports.default = SwipeableItem;